<db-create-ai-steps *ngIf="!recreationProcess" (onProceed)="startRecreation($event)"></db-create-ai-steps>
<db-create-ai-process *ngIf="recreationProcess"
                      [step]="step"
                      [websiteId]="websiteId"
                      [frontUrl]="frontUrl"></db-create-ai-process>
